import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./index.css";
import App from "./App.jsx";
import reportWebVitals from "./reportWebVitals";

createRoot(document.getElementById("root")).render(
      <React.StrictMode>
            <BrowserRouter>
                  <Routes>
                        <Route path="/" element={<App />} />
                  </Routes>
            </BrowserRouter>
      </React.StrictMode>
);

reportWebVitals();
